SidebarKo = App.loadClass "core::viewmodels/filters/Sidebar"

class exports.Audit_Handler extends Handler

    init: () ->
        @layoutUrl = 'backend/portal/audit/'
        @subHandlers =
            'Audit_Dialog':
                'class': 'portal::handlers/audit/Audit_Dialog'

        @defaultSub = 'Audit_Dialog'
        @loadLayout()


    afterLoadLayout: (selector, response) ->
        if response.status?.type isnt 'success'
            return

        filters = [
            {
                name: '',
                filters: [
                    {
                        name: 'years'
                        display_name: 'Sales Year'
                    },
                    {
                        name: 'states'
                        display_name: 'State'
                    },
                    {
                        name: 'changed_by'
                        display_name: 'Changed By'
                    },
                    {
                        name: 'changed_for'
                        display_name: 'Changed For'
                    },
                    {
                        name: 'order'
                        display_name: 'Order #'
                    },
                    {
                        name: 'start_date'
                        display_name: 'Start Date'
                        control_type: 'datepicker'
                    },
                    {
                        name: 'end_date'
                        display_name: 'End Date'
                        control_type: 'datepicker'
                    },
                ]
            }
        ]

        @sidebar = new SidebarKo filters
        #ko.cleanNode $(@layoutSelector)[0]
        ko.applyBindings @sidebar, $(@layoutSelector)[0]

        handler = @createSubHandler(@defaultSub)
        if handler
            handler.init()

        App.sidebar.element.find('.dpl').datepicker()

        $(@layoutSelector).find('.report-applied-filters').undelegate().delegate '.applied-filter-header', 'click', () ->
            $(this).siblings('.applied-filter-value-container').slideToggle('fast')
            if $(this).find('.caret-arrow').hasClass('caret-right')
                $(this).find('.caret-arrow').removeClass('caret-right')
            else
                $(this).find('.caret-arrow').addClass('caret-right')
